import { Pill } from "../Pill";
import { cn } from "../utils";

import { HeartIcon } from "./HeartIcon";

interface Props {
  followers: number;
  className?: string;
}
export function FollowersPill({ followers, className }: Props) {
  return (
    <Pill
      className={cn(
        "bg-gray-400 flex gap-1 justify-center items-center p-1.5 backdrop-blur",
        className,
      )}
    >
      <HeartIcon className="stroke-white/60 w-6 h-6 p-0.5" />
      <span className="text-white/60">{humanizeCount(followers)}</span>
    </Pill>
  );
}

function humanizeCount(count: number) {
  if (count < 1000) return count;
  if (count < 1000000) return `${(count / 1000).toFixed(1)}k`;
  return `${(count / 1000000).toFixed(1)}m`;
}
